"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionStatus = exports.SubscriptionPeriodType = exports.SubscriptionPeriods = exports.LocationSetBy = exports.TabBarStack = exports.TabBarRoute = exports.ColorModes = exports.Themes = exports.PublishingStatus = exports.PopupRowType = exports.ConsumableType = exports.PopupFormKeys = exports.PopupCardKeys = exports.TooltipKeys = exports.ChannelMessageTypes = exports.ReviewReason = exports.Roles = exports.ShareableSettings = exports.FirestoreCollections = exports.NamedFeeds = exports.ShareType = exports.AgreementOptions = exports.SignedInRoutes = exports.SignedOutRoutes = exports.EventCategory = exports.MediaStatus = exports.UploadStatus = exports.VideoProcessingStatus = exports.SupportedVideoOutputFormats = exports.UploadTypes = exports.InviteStatus = exports.BannedStatus = exports.Permissions = exports.NotificationSettingsKeys = exports.ChannelQualifiers = exports.ChannelDomains = exports.NotificationCategories = exports.SettingsGroupTypes = exports.NotificationTypes = exports.ActionSources = exports.ReportTypes = exports.StatusUpdates = exports.DomainObjects = exports.IDP = exports.PostOwnerType = exports.PostType = exports.ReservationStatus = exports.EventActivityRoute = exports.EventStatus = exports.ActionTypes = void 0;
exports.ContactIdType = exports.ContactType = exports.SyncStatus = exports.ActivityPrivacyMode = exports.WelcomeType = exports.ResourceLifecycle = exports.OnEventNavigateActions = exports.ClientMediaType = exports.PaywallVariation = exports.PostAttachmentTypes = exports.ImageNames = exports.IconNames = exports.RecommendationReasons = exports.PubSubTopics = exports.ProductSkus = exports.PurchaseEvents = exports.SubscriptionGroupNames = exports.ProductType = void 0;
var ActionTypes;
(function (ActionTypes) {
    // Accounts
    ActionTypes["NEW_USER"] = "NEW_USER";
    ActionTypes["DELETE_ACCOUNT"] = "DELETE_ACCOUNT";
    // Reports
    ActionTypes["REPORT_POST"] = "REPORT_POST";
    ActionTypes["REPORT_USER"] = "REPORT_USER";
    ActionTypes["REPORT_ENTITY"] = "REPORT_ENTITY";
    // Posts
    ActionTypes["SAVE_POST"] = "SAVE_POST";
    ActionTypes["UPDATE_POST"] = "UPDATE_POST";
    ActionTypes["RESTORE_POST"] = "RESTORE_POST";
    ActionTypes["DELETE_POST"] = "DELETE_POST";
    ActionTypes["DUPLICATE_POST"] = "DUPLICATE_POST";
    ActionTypes["CLEAR_POST_MEDIA"] = "CLEAR_POST_MEDIA";
    ActionTypes["ADMIN_DELETE_POST"] = "ADMIN_DELETE_POST";
    ActionTypes["PIN_POST"] = "PIN_POST";
    ActionTypes["UNPIN_POST"] = "UNPIN_POST";
    ActionTypes["DELETE_POSTS"] = "DELETE_POSTS";
    ActionTypes["DELETE_REVIEWED_POST"] = "DELETE_REVIEWED_POST";
    ActionTypes["HIDE_POST"] = "HIDE_POST";
    ActionTypes["DELETE_POST_MEDIA_V2"] = "DELETE_POST_MEDIA_V2";
    // Comments
    ActionTypes["SAVE_COMMENT"] = "SAVE_COMMENT";
    ActionTypes["REPORT_COMMENT"] = "REPORT_COMMENT";
    ActionTypes["DELETE_COMMENT"] = "DELETE_COMMENT";
    ActionTypes["DELETE_COMMENTS"] = "DELETE_COMMENTS";
    // Likes
    ActionTypes["SAVE_LIKE"] = "SAVE_LIKE";
    ActionTypes["DELETE_LIKE"] = "DELETE_LIKE";
    // Subs
    ActionTypes["SAVE_SUBSCRIBER"] = "SAVE_SUBSCRIBER";
    ActionTypes["DELETE_SUBSCRIBER"] = "DELETE_SUBSCRIBER";
    // Chats
    ActionTypes["SAVE_CHATROOM"] = "SAVE_CHATROOM";
    ActionTypes["DELETE_CHATROOM"] = "DELETE_CHATROOM";
    ActionTypes["SEND_MESSAGE"] = "SEND_MESSAGE";
    /**
     * Send a message on behalf of someone else. Useful for accounts which send messages
     * from the company.
     */
    ActionTypes["SEND_MESSAGE_PROXY"] = "SEND_MESSAGE_PROXY";
    ActionTypes["DELETE_MESSAGE"] = "DELETE_MESSAGE";
    ActionTypes["BLOCK_CHAT"] = "BLOCK_CHAT";
    ActionTypes["UNBLOCK_CHAT"] = "UNBLOCK_CHAT";
    ActionTypes["MESSAGE_VIEWED"] = "MESSAGE_VIEWED";
    ActionTypes["MESSAGE_VIEWED_ALL"] = "MESSAGE_VIEWED_ALL";
    // Notifications
    ActionTypes["NOTIFICATION_VIEWED"] = "NOTIFICATION_VIEWED";
    ActionTypes["SAVE_APP_UPDATE_NOTIFICATION"] = "SAVE_APP_UPDATE_NOTIFICATION";
    ActionTypes["DELETE_LEGACY_NOTIFICATION"] = "DELETE_LEGACY_NOTIFICATION";
    ActionTypes["DELETE_NOTIFICATION"] = "DELETE_NOTIFICATION";
    ActionTypes["MARK_ALL_AS_READ"] = "MARK_ALL_AS_READ";
    ActionTypes["MARK_AS_READ"] = "MARK_AS_READ";
    ActionTypes["MARK_CHANNELS_AS_READ"] = "MARK_CHANNELS_AS_READ";
    ActionTypes["SUBSCRIBE_NOTIFICATION_CHANNEL"] = "SUBSCRIBE_NOTIFICATION_CHANNEL";
    ActionTypes["UNSUBSCRIBE_NOTIFICATION_CHANNEL"] = "UNSUBSCRIBE_NOTIFICATION_CHANNEL";
    ActionTypes["PUSH_NOTIFICATIONS"] = "PUSH_NOTIFICATIONS";
    // Settings
    ActionTypes["SAVE_SETTING"] = "SAVE_SETTING";
    ActionTypes["SAVE_SETTINGS"] = "SAVE_SETTINGS";
    ActionTypes["UPDATE_PASSWORD"] = "UPDATE_PASSWORD";
    // Clubs
    ActionTypes["SAVE_CLUB"] = "SAVE_CLUB";
    ActionTypes["UPDATE_CLUB"] = "UPDATE_CLUB";
    ActionTypes["DELETE_CLUB"] = "DELETE_CLUB";
    ActionTypes["ARCHIVE_CLUB"] = "ARCHIVE_CLUB";
    ActionTypes["UNARCHIVE_CLUB"] = "UNARCHIVE_CLUB";
    ActionTypes["JOIN_CLUB"] = "JOIN_CLUB";
    ActionTypes["LEAVE_CLUB"] = "LEAVE_CLUB";
    ActionTypes["PROMOTE_CLUB_MEMBER"] = "PROMOTE_CLUB_MEMBER";
    ActionTypes["DEMOTE_CLUB_MEMBER"] = "DEMOTE_CLUB_MEMBER";
    ActionTypes["BAN_CLUB_MEMBER"] = "BAN_CLUB_MEMBER";
    ActionTypes["UNBAN_CLUB_MEMBER"] = "UNBAN_CLUB_MEMBER";
    ActionTypes["BLOCK_CLUB_MEMBER"] = "BLOCK_CLUB_MEMBER";
    ActionTypes["UNBLOCK_CLUB_MEMBER"] = "UNBLOCK_CLUB_MEMBER";
    ActionTypes["MAKE_CLUB_PRIVATE"] = "MAKE_CLUB_PRIVATE";
    ActionTypes["MAKE_CLUB_PUBLIC"] = "MAKE_CLUB_PUBLIC";
    ActionTypes["REPORT_CLUB"] = "REPORT_CLUB";
    ActionTypes["INVITE_TO_CLUB"] = "INVITE_TO_CLUB";
    ActionTypes["SHARE_POST_TO_CLUB"] = "SHARE_POST_TO_CLUB";
    ActionTypes["APPROVE_CLUB_INVITE"] = "APPROVE_CLUB_INVITE";
    ActionTypes["DECLINE_CLUB_INVITE"] = "DECLINE_CLUB_INVITE";
    // Media moderation callbacks
    ActionTypes["IMAGE_MODERATION_TAKEDOWN"] = "IMAGE_MODERATION_TAKEDOWN";
    ActionTypes["IMAGE_MODERATION_SUCCESS"] = "IMAGE_MODERATION_SUCCESS";
    ActionTypes["VIDEO_MODERATION_TAKEDOWN"] = "VIDEO_MODERATION_TAKEDOWN";
    ActionTypes["VIDEO_MODERATION_FAILED"] = "VIDEO_MODERATION_FAILED";
    ActionTypes["VIDEO_PROCESSING_SUCCESS"] = "VIDEO_PROCESSING_SUCCESS";
    ActionTypes["VIDEO_PROCESSING_FAILED"] = "VIDEO_PROCESSING_FAILED";
    ActionTypes["MEDIA_MODERATION_SUCCESS"] = "MEDIA_MODERATION_SUCCESS";
    ActionTypes["MEDIA_MODERATION_FAILURE"] = "MEDIA_MODERATION_FAILURE";
    // Flair
    ActionTypes["UPDATE_FLAIR"] = "UPDATE_FLAIR";
    ActionTypes["VISIT_PROFILE"] = "VISIT_PROFILE";
    // Social shares
    ActionTypes["SOCIAL_SHARE_POST"] = "SOCIAL_SHARE_POST";
    ActionTypes["GENERATE_SHORT_URL"] = "GENERATE_SHORT_URL";
    // Auth
    ActionTypes["SAVE_REGISTRATION_TOKEN"] = "SAVE_REGISTRATION_TOKEN";
    // Blocks
    ActionTypes["BLOCK"] = "BLOCK";
    ActionTypes["UNBLOCK"] = "UNBLOCK";
    // Account types
    ActionTypes["SET_ACCOUNT_TYPES"] = "SET_ACCOUNT_TYPES";
    // Events
    ActionTypes["CREATE_EVENT"] = "CREATE_EVENT";
    ActionTypes["UPDATE_EVENT"] = "UPDATE_EVENT";
    ActionTypes["CANCEL_EVENT"] = "CANCEL_EVENT";
    ActionTypes["ADD_EVENT_RESERVATION"] = "ADD_EVENT_RESERVATION";
    ActionTypes["SEND_EVENT_INVITE"] = "SEND_EVENT_INVITE";
    ActionTypes["REENABLE_EVENT"] = "REENABLE_EVENT";
    // Sessions
    ActionTypes["SESSION_START"] = "SESSION_START";
    ActionTypes["SESSION_END"] = "SESSION_END";
    // Hashtags
    ActionTypes["HASHTAG_CREATE"] = "HASHTAG_CREATE";
    ActionTypes["HASHTAG_SELECT"] = "HASHTAG_SELECT";
    // IAP
    ActionTypes["IAP_LOG_RECEIPT"] = "IAP_LOG_RECEIPT";
    ActionTypes["UPGRADE_TO_PREMIUM"] = "UPGRADE_TO_PREMIUM";
    ActionTypes["DOWNGRAGE_FROM_PREMIUM"] = "DOWNGRAGE_FROM_PREMIUM";
    // Profile
    ActionTypes["GARAGE_PRODUCT_UPDATE"] = "GARAGE_PRODUCT_UPDATE";
    ActionTypes["PROFILE_VIEW_UPDATE"] = "PROFILE_VIEW_UPDATE";
    ActionTypes["PROFILE_SET_USERNAME_READY"] = "PROFILE_SET_USERNAME_READY";
    ActionTypes["ONBOARDING_COMPLETE"] = "ONBOARDING_COMPLETE";
    // Gallery
    ActionTypes["GALLERY_FEATURE_MEDIA"] = "GALLERY_FEATURE_MEDIA";
    ActionTypes["GALLERY_REMOVE_MEDIA"] = "GALLERY_REMOVE_MEDIA";
    // Skills
    ActionTypes["SKILL_CUSTOM_ADD"] = "SKILL_CUSTOM_ADD";
    ActionTypes["SKILL_CUSTOM_REMOVE"] = "SKILL_CUSTOM_REMOVE";
    // Consumables
    ActionTypes["VIEW_CONSUMABLE"] = "VIEW_CONSUMABLE";
    // Activities
    ActionTypes["CREATE_ACTIVITY"] = "CREATE_ACTIVITY";
    ActionTypes["DELETE_ACTIVITY"] = "DELETE_ACTIVITY";
    ActionTypes["UPLOAD_COORDINATES"] = "UPLOAD_COORDINATES";
    ActionTypes["UPLOAD_COORDINATES_WINDOW"] = "UPLOAD_COORDINATES_WINDOW";
    ActionTypes["UPDATE_ACTIVITY"] = "UPDATE_ACTIVITY";
    // Support watch
    ActionTypes["SUPPORT_WATCH_ADD"] = "SUPPORT_WATCH_ADD";
    ActionTypes["SUPPORT_WATCH_REMOVE"] = "SUPPORT_WATCH_REMOVE";
    // New Users
    ActionTypes["SAVE_WELCOME_EVENT"] = "SAVE_WELCOME_EVENT";
    // Publish a post to the feed
    ActionTypes["PUBLISH_POST_TO_FEED"] = "PUBLISH_POST_TO_FEED";
    // Launch rails
    // Legacy
    // UPDATE_GEO_CIRCLE = "UPDATE_GEO_CIRCLE",
    // Config CRUD
    ActionTypes["LAUNCH_RAILS_ADD"] = "LAUNCH_RAILS_ADD";
    ActionTypes["LAUNCH_RAILS_REMOVE"] = "LAUNCH_RAILS_REMOVE";
    // Places CRUD
    ActionTypes["LAUNCH_RAILS_PLACE_ADD"] = "LAUNCH_RAILS_PLACE_ADD";
    ActionTypes["LAUNCH_RAILS_PLACE_REMOVE"] = "LAUNCH_RAILS_PLACE_REMOVE";
    // Config Places CRUD
    ActionTypes["LAUNCH_RAILS_PLACE_CONFIG_ADD"] = "LAUNCH_RAILS_PLACE_CONFIG_ADD";
    ActionTypes["LAUNCH_RAILS_PLACE_CONFIG_REMOVE"] = "LAUNCH_RAILS_PLACE_CONFIG_REMOVE";
    // User methods
    ActionTypes["LAUNCH_RAILS_SCHEDULE_STEP"] = "LAUNCH_RAILS_SCHEDULE_STEP";
    ActionTypes["LAUNCH_RAILS_DISPLAY_NEXT_STEP"] = "LAUNCH_RAILS_DISPLAY_NEXT_STEP";
    ActionTypes["LAUNCH_RAILS_STOP"] = "LAUNCH_RAILS_STOP";
    ActionTypes["DISPLAY_ALIASES"] = "DISPLAY_ALIASES";
    ActionTypes["ACTION_PROXY"] = "ACTION_PROXY";
    // Style Pilot
    ActionTypes["SP_UPDATE_AFFINITIES"] = "SP_UPDATE_AFFINITIES";
    // Feed Subscriptions
    ActionTypes["FEED_SUBSCRIBE"] = "FEED_SUBSCRIBE";
    ActionTypes["FEED_UNSUBSCRIBE"] = "FEED_UNSUBSCRIBE";
    // Feed Subscriptions admin actions
    ActionTypes["FEED_SUB_ADMIN_LIST"] = "FEED_SUB_ADMIN_LIST";
    ActionTypes["FEED_SUB_ADMIN_SUBSCRIBE"] = "FEED_SUB_ADMIN_SUBSCRIBE";
    ActionTypes["FEED_SUB_ADMIN_UNSUBSCRIBE"] = "FEED_SUB_ADMIN_UNSUBSCRIBE";
    // Contacts
    ActionTypes["SAVE_DEVICE_CONTACTS"] = "SAVE_DEVICE_CONTACTS";
    ActionTypes["SAVE_FACEBOOK_FRIENDS"] = "SAVE_FACEBOOK_FRIENDS";
    ActionTypes["POST_IMPRESSIONS"] = "POST_IMPRESSIONS";
    ActionTypes["SAVE_FAVORITE"] = "SAVE_FAVORITE";
    ActionTypes["DELETE_FAVORITE"] = "DELETE_FAVORITE";
    // Suspensions
    ActionTypes["SUSPENSION_RESOLVE"] = "SUSPENSION_RESOLVE";
    ActionTypes["SUSPENSION_CREATE"] = "SUSPENSION_CREATE";
    ActionTypes["UGC_REMOVE_ALL"] = "UGC_REMOVE_ALL";
})(ActionTypes = exports.ActionTypes || (exports.ActionTypes = {}));
var EventStatus;
(function (EventStatus) {
    EventStatus["ACTIVE"] = "active";
    EventStatus["CANCELLED"] = "cancelled";
    EventStatus["COMPLETED"] = "completed";
})(EventStatus = exports.EventStatus || (exports.EventStatus = {}));
var EventActivityRoute;
(function (EventActivityRoute) {
    EventActivityRoute["ACCEPTED"] = "accepted";
    EventActivityRoute["INTERESTED"] = "interested";
    EventActivityRoute["COMMENTS"] = "comments";
})(EventActivityRoute = exports.EventActivityRoute || (exports.EventActivityRoute = {}));
var ReservationStatus;
(function (ReservationStatus) {
    ReservationStatus["ACCEPTED"] = "accepted";
    ReservationStatus["INTERESTED"] = "interested";
    ReservationStatus["DECLINED"] = "declined";
})(ReservationStatus = exports.ReservationStatus || (exports.ReservationStatus = {}));
/**
 * Types of posts (news feed items)
 */
var PostType;
(function (PostType) {
    PostType["Post"] = "posts";
    PostType["Ride"] = "rides";
    PostType["ClubPost"] = "club-posts";
    PostType["ClubRide"] = "club-rides";
    PostType["Activity"] = "activities";
    PostType["Event"] = "events";
})(PostType = exports.PostType || (exports.PostType = {}));
/**
 * Post Owner Types
 */
var PostOwnerType;
(function (PostOwnerType) {
    PostOwnerType["Profile"] = "profiles";
    PostOwnerType["Club"] = "clubs";
})(PostOwnerType = exports.PostOwnerType || (exports.PostOwnerType = {}));
/**
 * Account IDP Types
 */
var IDP;
(function (IDP) {
    IDP["TONIT"] = "tonit";
    IDP["FACEBOOK"] = "facebook";
    IDP["APPLE"] = "apple";
})(IDP = exports.IDP || (exports.IDP = {}));
/**
 * Generic Domain Object Types
 */
var DomainObjects;
(function (DomainObjects) {
    DomainObjects["Action"] = "Action";
    DomainObjects["Activity"] = "Activity";
    DomainObjects["Affinity"] = "Affinity";
    DomainObjects["Comment"] = "Comment";
    DomainObjects["Consumable"] = "Consumable";
    DomainObjects["Club"] = "Club";
    DomainObjects["Event"] = "Event";
    DomainObjects["Feedback"] = "Feedback";
    DomainObjects["FeedItem"] = "FeedItem";
    DomainObjects["Like"] = "Like";
    DomainObjects["Location"] = "Location";
    DomainObjects["Message"] = "Message";
    DomainObjects["Post"] = "Post";
    DomainObjects["Profile"] = "Profile";
    DomainObjects["Report"] = "Report";
    DomainObjects["ReportReasons"] = "ReportReasons";
    DomainObjects["Reservation"] = "Reservation";
    DomainObjects["Ride"] = "Ride";
    DomainObjects["RidingStyle"] = "RidingStyle";
    DomainObjects["Subscriber"] = "Subscriber";
    DomainObjects["Room"] = "Room";
    DomainObjects["Setting"] = "Setting";
    DomainObjects["Trigger"] = "Trigger";
    DomainObjects["User"] = "User";
    DomainObjects["Wishlist"] = "Wishlist";
    // Garage stuff
    DomainObjects["Bike"] = "Bike";
    DomainObjects["Gear"] = "Gear";
    DomainObjects["Mod"] = "Mod";
    DomainObjects["SharedContact"] = "SharedContact";
    DomainObjects["FoundContact"] = "FoundContact";
})(DomainObjects = exports.DomainObjects || (exports.DomainObjects = {}));
/**
 * Generic Satus Update Types.
 */
var StatusUpdates;
(function (StatusUpdates) {
    StatusUpdates["READY"] = "READY";
    StatusUpdates["PENDING"] = "PENDING";
    StatusUpdates["FAILED"] = "FAILED";
})(StatusUpdates = exports.StatusUpdates || (exports.StatusUpdates = {}));
/**
 * Types of reports
 */
var ReportTypes;
(function (ReportTypes) {
    ReportTypes["Post"] = "Post";
    ReportTypes["Comment"] = "Comment";
    ReportTypes["Profile"] = "Profile";
    ReportTypes["Club"] = "Club";
})(ReportTypes = exports.ReportTypes || (exports.ReportTypes = {}));
/**
 * Sources of actions
 */
var ActionSources;
(function (ActionSources) {
    ActionSources["lambda"] = "tonit-lambda";
    ActionSources["node"] = "tonit-node";
    ActionSources["firebase"] = "tonit-firebase";
    ActionSources["nodev2"] = "tonit-node-v2";
})(ActionSources = exports.ActionSources || (exports.ActionSources = {}));
/**
 * @legacy
 * Types of notifications that a user can receive
 * Not all types are necessarily implemented
 */
var NotificationTypes;
(function (NotificationTypes) {
    NotificationTypes["POST_COMMENT"] = "POST_COMMENT";
    NotificationTypes["RIDE_COMMENT"] = "RIDE_COMMENT";
    NotificationTypes["POST_COMMENT_COMMENT"] = "POST_COMMENT_COMMENT";
    NotificationTypes["RIDE_COMMENT_COMMENT"] = "RIDE_COMMENT_COMMENT";
    NotificationTypes["MESSAGE"] = "MESSAGE";
    NotificationTypes["POST"] = "POST";
    NotificationTypes["RESTORED_REVIEWABLE"] = "RESTORED_REVIEWABLE";
    NotificationTypes["DELETED_REVIEWABLE"] = "DELETED_REVIEWABLE";
    NotificationTypes["RIDE"] = "RIDE";
    NotificationTypes["ACCOLADE"] = "ACCOLADE";
    NotificationTypes["POST_LIKE"] = "POST_LIKE";
    NotificationTypes["RIDE_LIKE"] = "RIDE_LIKE";
    NotificationTypes["FOLLOWER"] = "FOLLOWER";
    NotificationTypes["APP_UPDATE"] = "APP_UPDATE";
    NotificationTypes["GROUPED_NOTIFICATIONS"] = "GROUPED_NOTIFICATIONS";
    NotificationTypes["CLUB_INVITE"] = "CLUB_INVITE";
    NotificationTypes["JOIN_CLUB"] = "JOIN_CLUB";
    NotificationTypes["LEAVE_CLUB"] = "LEAVE_CLUB";
    NotificationTypes["CLUB_INVITE_ACCEPTED"] = "CLUB_INVITE_ACCEPTED";
    NotificationTypes["CLUB_INVITE_DECLINED"] = "CLUB_INVITE_DECLINED";
    NotificationTypes["CLUB_JOIN_REQUEST"] = "CLUB_JOIN_REQUEST";
    NotificationTypes["CLUB_POST_ADDED"] = "CLUB_POST_ADDED";
    NotificationTypes["REJECTED_MEDIA"] = "REJECTED_MEDIA";
    NotificationTypes["MEDIA_PROCESSING_SUCCESS"] = "MEDIA_PROCESSING_SUCCESS";
})(NotificationTypes = exports.NotificationTypes || (exports.NotificationTypes = {}));
/**
 * Different category types of settings
 * Used in endpoints in Firebase eg. settings/userid/notifications/
 * @legacy
 */
var SettingsGroupTypes;
(function (SettingsGroupTypes) {
    SettingsGroupTypes["NOTIFICATION"] = "notifications";
})(SettingsGroupTypes = exports.SettingsGroupTypes || (exports.SettingsGroupTypes = {}));
/**
 * Visual categories to distinguish
 * notifications
 */
var NotificationCategories;
(function (NotificationCategories) {
    NotificationCategories["club"] = "club";
    NotificationCategories["message"] = "message";
    NotificationCategories["like"] = "like";
    NotificationCategories["comment"] = "comment";
    NotificationCategories["follow"] = "follow";
    NotificationCategories["accolade"] = "accolade";
    NotificationCategories["admin"] = "admin";
    NotificationCategories["event"] = "event";
    NotificationCategories["recommendation"] = "recommendation";
})(NotificationCategories = exports.NotificationCategories || (exports.NotificationCategories = {}));
/**
 * Notification channels are of the format:
 *
 * ${Channels}-${channelId}
 *
 * or
 *
 * ${Channels}-${channelId}-${optionalQualifiers}
 *
 * ex: `${Channels.club}-${club.id}-${Subchannels.posts}`
 *     `${Channels.post}-${post.id}`
 */
var ChannelDomains;
(function (ChannelDomains) {
    ChannelDomains["club"] = "club";
    ChannelDomains["feed"] = "feed";
    ChannelDomains["message"] = "message";
    ChannelDomains["post"] = "post";
    ChannelDomains["ride"] = "ride";
    ChannelDomains["user"] = "user";
    ChannelDomains["mention"] = "mention";
    ChannelDomains["admin"] = "admin";
    ChannelDomains["posts"] = "posts";
    ChannelDomains["followers"] = "followers";
    ChannelDomains["messages"] = "messages";
    ChannelDomains["comments"] = "comments";
    ChannelDomains["likes"] = "likes";
    ChannelDomains["clubinvites"] = "clubinvites";
    ChannelDomains["mentions"] = "mentions";
    ChannelDomains["event"] = "event";
})(ChannelDomains = exports.ChannelDomains || (exports.ChannelDomains = {}));
var ChannelQualifiers;
(function (ChannelQualifiers) {
    ChannelQualifiers["comments"] = "comments";
    ChannelQualifiers["invites"] = "invites";
    ChannelQualifiers["likes"] = "likes";
    ChannelQualifiers["membership"] = "membership";
    ChannelQualifiers["posts"] = "posts";
    ChannelQualifiers["admin"] = "admin";
    ChannelQualifiers["recommendations"] = "recommendations";
    ChannelQualifiers["scheduling"] = "scheduling";
})(ChannelQualifiers = exports.ChannelQualifiers || (exports.ChannelQualifiers = {}));
/** legacy, replaced with channels */
var NotificationSettingsKeys;
(function (NotificationSettingsKeys) {
    NotificationSettingsKeys["posts"] = "posts";
    NotificationSettingsKeys["followers"] = "followers";
    NotificationSettingsKeys["messages"] = "messages";
    NotificationSettingsKeys["comments"] = "comments";
    NotificationSettingsKeys["likes"] = "likes";
    NotificationSettingsKeys["clubinvites"] = "clubinvites";
    NotificationSettingsKeys["admin"] = "admin";
    NotificationSettingsKeys["mentions"] = "mentions";
    NotificationSettingsKeys["events"] = "events";
})(NotificationSettingsKeys = exports.NotificationSettingsKeys || (exports.NotificationSettingsKeys = {}));
var Permissions;
(function (Permissions) {
    Permissions["changeRole"] = "change-role";
    Permissions["writePost"] = "write-post";
    Permissions["readPost"] = "read-post";
    Permissions["removeUserPost"] = "remove-user-post";
    Permissions["pinPost"] = "pin-post";
    Permissions["removeUser"] = "remove-user";
    Permissions["banUser"] = "ban-user";
    Permissions["leave"] = "leave";
    Permissions["inviteUser"] = "invite-user";
    Permissions["manageJoinRequest"] = "manage-join-request";
    Permissions["deleteClub"] = "delete-club";
    Permissions["archiveClub"] = "archive-club";
    Permissions["changeVisibility"] = "change-visibility";
    Permissions["editClub"] = "edit-club";
    Permissions["adminDashboard"] = "admin-dashboard";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
var BannedStatus;
(function (BannedStatus) {
    BannedStatus["banned"] = "banned";
    BannedStatus["unbanned"] = "unbanned";
})(BannedStatus = exports.BannedStatus || (exports.BannedStatus = {}));
var InviteStatus;
(function (InviteStatus) {
    InviteStatus["requestedJoin"] = "requestedJoin";
    InviteStatus["invited"] = "invited";
    InviteStatus["accepted"] = "accepted";
    InviteStatus["declined"] = "declined";
})(InviteStatus = exports.InviteStatus || (exports.InviteStatus = {}));
var UploadTypes;
(function (UploadTypes) {
    UploadTypes["video"] = "video";
    UploadTypes["image"] = "image";
})(UploadTypes = exports.UploadTypes || (exports.UploadTypes = {}));
var SupportedVideoOutputFormats;
(function (SupportedVideoOutputFormats) {
    SupportedVideoOutputFormats["dash"] = "dash";
    SupportedVideoOutputFormats["hls"] = "hls";
    SupportedVideoOutputFormats["mp4_720p"] = "mp4_720p";
    SupportedVideoOutputFormats["mp4_1080p"] = "mp4_1080p";
})(SupportedVideoOutputFormats = exports.SupportedVideoOutputFormats || (exports.SupportedVideoOutputFormats = {}));
/**
 * Lambda Workflow Status
 */
var VideoProcessingStatus;
(function (VideoProcessingStatus) {
    VideoProcessingStatus["COMPLETE"] = "Complete";
    VideoProcessingStatus["INGEST"] = "Ingest";
    VideoProcessingStatus["FAILED"] = "Failed";
    VideoProcessingStatus["MODERATOR_REJECT"] = "ModeratorReject";
    VideoProcessingStatus["MODERATOR_COMPLETE"] = "ModeratorComplete";
})(VideoProcessingStatus = exports.VideoProcessingStatus || (exports.VideoProcessingStatus = {}));
var UploadStatus;
(function (UploadStatus) {
    UploadStatus["pending"] = "pending";
    UploadStatus["succeeded"] = "succeeded";
    UploadStatus["failed"] = "failed";
})(UploadStatus = exports.UploadStatus || (exports.UploadStatus = {}));
var MediaStatus;
(function (MediaStatus) {
    MediaStatus["pending"] = "pending";
    MediaStatus["succeeded"] = "succeeded";
    MediaStatus["failed"] = "failed";
    MediaStatus["noResponse"] = "no-response";
})(MediaStatus = exports.MediaStatus || (exports.MediaStatus = {}));
var EventCategory;
(function (EventCategory) {
    EventCategory["INTERACTION"] = "INTERACTION";
    EventCategory["OPERATION"] = "OPERATION";
})(EventCategory = exports.EventCategory || (exports.EventCategory = {}));
var SignedOutRoutes;
(function (SignedOutRoutes) {
    SignedOutRoutes["ForgotPassword"] = "ForgotPassword";
    SignedOutRoutes["Landing"] = "Landing";
    SignedOutRoutes["Legal"] = "Legal";
    SignedOutRoutes["Login"] = "Login";
    SignedOutRoutes["Privacy"] = "Privacy";
    SignedOutRoutes["Register"] = "Register";
    SignedOutRoutes["RegisterFacebook"] = "RegisterFacebook";
    SignedOutRoutes["RegisterEmail"] = "RegisterEmail";
})(SignedOutRoutes = exports.SignedOutRoutes || (exports.SignedOutRoutes = {}));
var SignedInRoutes;
(function (SignedInRoutes) {
    SignedInRoutes["AccountSettings"] = "AccountSettings";
    SignedInRoutes["AddEditClub"] = "AddEditClub";
    SignedInRoutes["Bio"] = "Bio";
    SignedInRoutes["Bike"] = "Bike";
    SignedInRoutes["BlockedUsers"] = "BlockedUsers";
    SignedInRoutes["Chats"] = "Chats";
    SignedInRoutes["Collection"] = "Collection";
    SignedInRoutes["Comments"] = "Comments";
    SignedInRoutes["Club"] = "Club";
    SignedInRoutes["ClubAdminLanding"] = "ClubAdminLanding";
    SignedInRoutes["ClubInvite"] = "ClubInvite";
    SignedInRoutes["ClubInfo"] = "ClubInfo";
    SignedInRoutes["ClubManageMembers"] = "ClubManageMembers";
    SignedInRoutes["ClubMemberList"] = "ClubMemberList";
    SignedInRoutes["ClubSettings"] = "ClubSettings";
    SignedInRoutes["Conversation"] = "Conversation";
    SignedInRoutes["EditBike"] = "EditBike";
    SignedInRoutes["EditProfile"] = "EditProfile";
    SignedInRoutes["Followers"] = "Followers";
    SignedInRoutes["Followings"] = "Followings";
    SignedInRoutes["Legal"] = "Legal";
    SignedInRoutes["Likes"] = "Likes";
    SignedInRoutes["Main"] = "Main";
    SignedInRoutes["Notifications"] = "Notifications";
    SignedInRoutes["Onboarding"] = "Onboarding";
    SignedInRoutes["Tutorial"] = "Tutorial";
    SignedInRoutes["Post"] = "Post";
    SignedInRoutes["Privacy"] = "Privacy";
    SignedInRoutes["Profile"] = "Profile";
    SignedInRoutes["UpdatePassword"] = "UpdatePassword";
    SignedInRoutes["ReportBug"] = "ReportBug";
    SignedInRoutes["RideSummary"] = "RideSummary";
    SignedInRoutes["SearchRiders"] = "SearchRiders";
    SignedInRoutes["Settings"] = "Settings";
    SignedInRoutes["SettingsV2"] = "SettingsV2";
    SignedInRoutes["Compose"] = "Compose";
    SignedInRoutes["Report"] = "Report";
    SignedInRoutes["HelpCenter"] = "HelpCenter";
    SignedInRoutes["Feed"] = "Feed";
    SignedInRoutes["Clubs"] = "Clubs";
    SignedInRoutes["Map"] = "Map";
    SignedInRoutes["Find"] = "Find";
    SignedInRoutes["More"] = "More";
    SignedInRoutes["HashtagFeed"] = "HashtagFeed";
    SignedInRoutes["LocationFeed"] = "LocationFeed";
    // event routes
    SignedInRoutes["EventDetails"] = "EventDetails";
    SignedInRoutes["ComposeEvent"] = "ComposeEvent";
    SignedInRoutes["EventActivity"] = "EventActivity";
    SignedInRoutes["PastReservations"] = "PastReservations";
    SignedInRoutes["EventShare"] = "EventShare";
    SignedInRoutes["EventInviteUser"] = "EventInviteUser";
    // premium
    SignedInRoutes["PremiumSignUp"] = "PremiumSignUp";
    SignedInRoutes["PremiumSuccess"] = "PremiumSuccess";
    SignedInRoutes["Subscription"] = "Subscription";
    SignedInRoutes["Paywall"] = "Paywall";
    SignedInRoutes["ManageSubscription"] = "ManageSubscription";
    SignedInRoutes["CancelSubscription"] = "CancelSubscription";
    SignedInRoutes["ChangeSubscription"] = "ChangeSubscription";
    SignedInRoutes["CancelConfirm"] = "CancelConfirm";
    SignedInRoutes["RidingSkills"] = "RidingSkills";
    SignedInRoutes["ClubsList"] = "ClubsList";
    SignedInRoutes["RidingStyles"] = "RidingStyles";
    SignedInRoutes["RidesList"] = "RidesList";
    SignedInRoutes["AddEditBike"] = "AddEditBike";
    SignedInRoutes["GearList"] = "GearList";
    SignedInRoutes["WishlistList"] = "WishlistList";
    SignedInRoutes["ProfileV2"] = "ProfileV2";
    SignedInRoutes["BikeV2"] = "BikeV2";
    SignedInRoutes["ProfileGate"] = "ProfileGate";
    SignedInRoutes["AddEditMod"] = "AddEditMod";
    SignedInRoutes["AddEditGear"] = "AddEditGear";
    SignedInRoutes["EventList"] = "EventList";
    SignedInRoutes["EditBio"] = "EditBio";
    // settings screens
    SignedInRoutes["GeneralStg"] = "GeneralStg";
    SignedInRoutes["NotificationStg"] = "NotificationStg";
    SignedInRoutes["LanguagesStg"] = "LanguagesStg";
    SignedInRoutes["IapTrial"] = "IapTrial";
    SignedInRoutes["DeleleAccount"] = "DeleleAccount";
    // tracking screens
    SignedInRoutes["ComposeTracking"] = "ComposeTracking";
    SignedInRoutes["PastActivities"] = "PastActivities";
    SignedInRoutes["ActivityDetails"] = "ActivityDetails";
    SignedInRoutes["ActivityMapView"] = "ActivityMapView";
    // referrals
    SignedInRoutes["Invite"] = "Invite";
    SignedInRoutes["Contacts"] = "Contacts";
})(SignedInRoutes = exports.SignedInRoutes || (exports.SignedInRoutes = {}));
var AgreementOptions;
(function (AgreementOptions) {
    AgreementOptions["NONE"] = "none";
    AgreementOptions["IMPLICIT"] = "implicit";
    AgreementOptions["EXPLICIT"] = "explicit";
})(AgreementOptions = exports.AgreementOptions || (exports.AgreementOptions = {}));
var ShareType;
(function (ShareType) {
    ShareType["Post"] = "posts";
    ShareType["Ride"] = "rides";
    ShareType["ClubPost"] = "club-posts";
    ShareType["ClubRide"] = "club-rides";
    ShareType["Club"] = "club";
    ShareType["Event"] = "event";
    ShareType["Profile"] = "profile";
    ShareType["Invite"] = "invite";
})(ShareType = exports.ShareType || (exports.ShareType = {}));
var NamedFeeds;
(function (NamedFeeds) {
    NamedFeeds["LOCAL"] = "local";
    NamedFeeds["GLOBAL"] = "global";
    NamedFeeds["FOLLOWING"] = "following";
    NamedFeeds["CLUB"] = "club";
    NamedFeeds["POSTS"] = "posts";
    NamedFeeds["RIDES"] = "rides";
    NamedFeeds["POSTSCREEN"] = "postScreen";
    NamedFeeds["COMBINED"] = "combined";
})(NamedFeeds = exports.NamedFeeds || (exports.NamedFeeds = {}));
var FirestoreCollections;
(function (FirestoreCollections) {
    /**
     * collection: notifications
     * - doc: {notificationId}
     */
    FirestoreCollections["notifications"] = "notifications";
    /**
     * collection: deletedNotifications
     * - doc: {notificationId}
     */
    FirestoreCollections["deletedNotifications"] = "deletedNotifications";
    /**
     * collection: notificationSettings
     * - doc: {userId}
     */
    FirestoreCollections["notificationSettings"] = "notificationSettings";
    /**
     * collection: unsubscribedChannels
     * - doc: {channelId}
     * - - subcollection: users
     * - - - doc: {userId}
     */
    FirestoreCollections["unsubscribedChannels"] = "unsubscribedChannels";
    /**
     * collection: uiPreferences
     * - doc: userId
     */
    FirestoreCollections["uiPreferences"] = "uiPreferences";
    /**
     * collection: settings
     * - doc: userId
     */
    FirestoreCollections["settings"] = "settings";
})(FirestoreCollections = exports.FirestoreCollections || (exports.FirestoreCollections = {}));
var ShareableSettings;
(function (ShareableSettings) {
    ShareableSettings["ResourceOwner"] = "ResourceOwner";
    ShareableSettings["ResourceModerators"] = "ResourceModerators";
    /**
     * owners following
     */
    ShareableSettings["OwnersSubscribers"] = "OwnersSubscribers";
    /**
     * users subscribing to same resource eg. club members
     */
    ShareableSettings["ResourceSubscribers"] = "ResourceSubscribers";
    ShareableSettings["Everyone"] = "Everyone";
})(ShareableSettings = exports.ShareableSettings || (exports.ShareableSettings = {}));
var Roles;
(function (Roles) {
    Roles["MEMBER"] = "member";
    Roles["OWNER"] = "owner";
    Roles["MODERATOR"] = "moderator";
})(Roles = exports.Roles || (exports.Roles = {}));
var ReviewReason;
(function (ReviewReason) {
    ReviewReason["MODERATION"] = "moderation";
    ReviewReason["REPORTS"] = "reports";
    ReviewReason["ADMIN"] = "admin";
})(ReviewReason = exports.ReviewReason || (exports.ReviewReason = {}));
// real time messages sent to the subscribers of the channels
// atm it will just be directly to users relating to there posts
var ChannelMessageTypes;
(function (ChannelMessageTypes) {
    ChannelMessageTypes["AFFINITY_MUTUAL_NEW"] = "AFFINITY_MUTUAL_NEW";
    ChannelMessageTypes["POST_RESTORE"] = "POST_RESTORE";
    ChannelMessageTypes["POST_REVIEW"] = "POST_REVIEW";
    ChannelMessageTypes["POST_DELETE"] = "POST_DELETE";
    ChannelMessageTypes["POST_MEDIA_SUCCESS"] = "POST_MEDIA_SUCCESS";
    ChannelMessageTypes["POST_MEDIA_FAILURE"] = "POST_MEDIA_FAILURE";
    ChannelMessageTypes["POST_RESOLVED"] = "POST_RESOLVED";
    ChannelMessageTypes["UPGRADE_TO_PREMIUM"] = "UPGRADE_TO_PREMIUM";
    ChannelMessageTypes["DOWNGRAGE_FROM_PREMIUM"] = "DOWNGRAGE_FROM_PREMIUM";
    ChannelMessageTypes["IAPHUB_WEBHOOK"] = "IAPHUB_WEBHOOK";
    ChannelMessageTypes["PROFILE_MEDIA_SUCCESS"] = "PROFILE_MEDIA_SUCCESS";
    ChannelMessageTypes["PROFILE_MEDIA_FAILURE"] = "PROFILE_MEDIA_FAILURE";
    ChannelMessageTypes["GARAGE_MEDIA_SUCCESS"] = "GARAGE_MEDIA_SUCCESS";
    ChannelMessageTypes["GARAGE_MEDIA_FAILURE"] = "GARAGE_MEDIA_FAILURE";
    ChannelMessageTypes["CONTACT_INGESTION_SUCCESS"] = "CONTACT_INGESTION_SUCCESS";
    ChannelMessageTypes["CONTACT_INGESTION_FAILURE"] = "CONTACT_INGESTION_FAILURE";
    ChannelMessageTypes["EVENT_MEDIA_SUCCESS"] = "EVENT_MEDIA_SUCCESS";
    ChannelMessageTypes["EVENT_MEDIA_FAILURE"] = "EVENT_MEDIA_FAILURE";
})(ChannelMessageTypes = exports.ChannelMessageTypes || (exports.ChannelMessageTypes = {}));
/**
 * Keys for all available tooltips
 */
var TooltipKeys;
(function (TooltipKeys) {
    TooltipKeys["COMPOSE_SCREEN_MENTIONS"] = "compose-screen/mentions";
    TooltipKeys["FEED_SCREEN_COMPOSE"] = "feed-screen/compose";
    TooltipKeys["FEED_SCREEN_COMPOSE_RIDE_TRACKING"] = "feed-screen/compose-ride-tracking";
    TooltipKeys["CLUB_SCREEN_MUTE_NOTIFICATIONS"] = "club-screen/mute-notifications";
    TooltipKeys["NOTIFICATIONS_SCREEN_DELETE_NOTIFICATION"] = "notifications-screen/delete-notification";
    TooltipKeys["COMPOSE_SCREEN_LOCATIONS"] = "compose-screen/locations";
    TooltipKeys["COMPOSE_SCREEN_HASHTAGS"] = "compose-screen/hashtags";
    TooltipKeys["DISCOVERY"] = "tab-nav/discovery";
    TooltipKeys["DISCOVER_SCREEN_SEARCH_FILTER"] = "discover-screen/search-filter";
    TooltipKeys["CLUBS_SCREEN_COMPOSE"] = "clubs-screen/compose";
    TooltipKeys["FILTER_FEED"] = "feed-screen/filter-feed";
})(TooltipKeys = exports.TooltipKeys || (exports.TooltipKeys = {}));
/**
 * Keys for all available popupCards
 */
var PopupCardKeys;
(function (PopupCardKeys) {
    PopupCardKeys["FEED_SCREEN_ONBOARDING"] = "feed-screen/onboarding";
    PopupCardKeys["PROFILE_SCREEN_ONBOARDING"] = "profile-screen/onboarding";
    PopupCardKeys["CLUBS_SCREEN_ONBOARDING"] = "clubs-screen/onboarding";
    PopupCardKeys["SEARCH_SCREEN_ONBOARDING"] = "search-screen/onboarding";
    PopupCardKeys["DISCOVERY_SCREEN_ONBOARDING"] = "explore-screen/onboarding";
})(PopupCardKeys = exports.PopupCardKeys || (exports.PopupCardKeys = {}));
var PopupFormKeys;
(function (PopupFormKeys) {
    PopupFormKeys["FEEDBACK"] = "feed-screen/feedback-form";
    // 2020 feedback
    PopupFormKeys["FEEDBACK_V2"] = "feed-screen/feedback-form-v2";
    // 2022
    PopupFormKeys["FEEDBACK_NEW_USERS"] = "feed-screen/feedback-new-users";
})(PopupFormKeys = exports.PopupFormKeys || (exports.PopupFormKeys = {}));
/**
 * Types of consumables available
 */
var ConsumableType;
(function (ConsumableType) {
    ConsumableType["TOOLTIP"] = "tooltip";
    ConsumableType["POPUPCARD"] = "popupCard";
    ConsumableType["POPUPFORM"] = "popupForm";
})(ConsumableType = exports.ConsumableType || (exports.ConsumableType = {}));
var PopupRowType;
(function (PopupRowType) {
    PopupRowType["HERO"] = "hero";
    PopupRowType["TEXT"] = "text";
    PopupRowType["LIST"] = "list";
    PopupRowType["ACTION"] = "action";
    PopupRowType["SUBCARD"] = "subcard";
})(PopupRowType = exports.PopupRowType || (exports.PopupRowType = {}));
/**
 * Feed Item publish status
 */
var PublishingStatus;
(function (PublishingStatus) {
    PublishingStatus["PUBLISHED"] = "Published";
    PublishingStatus["FAILED"] = "Failed";
    PublishingStatus["PROCESSING"] = "Processing";
    PublishingStatus["CANCELLED"] = "Cancelled";
})(PublishingStatus = exports.PublishingStatus || (exports.PublishingStatus = {}));
var Themes;
(function (Themes) {
    Themes["light"] = "light";
    Themes["dark"] = "dark";
})(Themes = exports.Themes || (exports.Themes = {}));
var ColorModes;
(function (ColorModes) {
    ColorModes["light"] = "light";
    ColorModes["dark"] = "dark";
})(ColorModes = exports.ColorModes || (exports.ColorModes = {}));
/**
 * constants for the client side tab bar routes
 */
var TabBarRoute;
(function (TabBarRoute) {
    TabBarRoute["FEED"] = "Feed";
    TabBarRoute["CLUBS"] = "Clubs";
    TabBarRoute["PROFILE"] = "MyProfile";
    TabBarRoute["FIND"] = "Find";
    TabBarRoute["MORE"] = "More";
    TabBarRoute["EVENTS"] = "Events";
})(TabBarRoute = exports.TabBarRoute || (exports.TabBarRoute = {}));
var TabBarStack;
(function (TabBarStack) {
    TabBarStack["FEED"] = "FeedStack";
    TabBarStack["CLUB"] = "ClubStack";
    TabBarStack["PROFILE"] = "ProfileStack";
    TabBarStack["FIND"] = "FindStack";
    TabBarStack["MORE"] = "MoreStack";
    TabBarStack["MAP"] = "MapStack";
})(TabBarStack = exports.TabBarStack || (exports.TabBarStack = {}));
/**
 * How was the location set (ie. on posts)
 */
var LocationSetBy;
(function (LocationSetBy) {
    LocationSetBy["PROFILE"] = "profile";
    LocationSetBy["USER"] = "user";
    LocationSetBy["LOCATION"] = "location";
})(LocationSetBy = exports.LocationSetBy || (exports.LocationSetBy = {}));
/**
 * Subscription period values returned for a product from iTunes/GP
 */
var SubscriptionPeriods;
(function (SubscriptionPeriods) {
    SubscriptionPeriods["PER_1_WEEK_IOS"] = "P7D";
    SubscriptionPeriods["PER_1_WEEK_ANDROID"] = "P1W";
    SubscriptionPeriods["PER_1_MONTH"] = "P1M";
    SubscriptionPeriods["PER_3_MONTHS"] = "P3M";
    SubscriptionPeriods["PER_6_MONTHS"] = "P6M";
    SubscriptionPeriods["PER_1_YEAR"] = "P1Y";
})(SubscriptionPeriods = exports.SubscriptionPeriods || (exports.SubscriptionPeriods = {}));
var SubscriptionPeriodType;
(function (SubscriptionPeriodType) {
    SubscriptionPeriodType["NORMAL"] = "normal";
    SubscriptionPeriodType["TRIAL"] = "trial";
    SubscriptionPeriodType["INTRO"] = "intro";
})(SubscriptionPeriodType = exports.SubscriptionPeriodType || (exports.SubscriptionPeriodType = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "Active";
    /**
     * Cancelled still means the subscription is valid and active but will expire
     */
    SubscriptionStatus["CANCELLED"] = "Cancelled";
    /**
     * Subscription is still valid but we're into the grace period (eg 1 week)
     */
    SubscriptionStatus["RETRYPERIOD"] = "RetryPeriod";
    // --- All statuses below the subscriptions are considered inactive ---
    SubscriptionStatus["EXPIRED"] = "Expired";
    SubscriptionStatus["REFUNDED"] = "Refunded";
    SubscriptionStatus["REPLACED"] = "Replaced";
    /**
     * Subscription transferred to another user id eg. `PurchaseEvents.UserIdUpdate`
     */
    SubscriptionStatus["TRANSFERRED"] = "Transferred";
    /**
     * Paused subscription (android only) -> https://developer.android.com/google/play/billing/subscriptions#pauseusers
     * Users can choose to pause their subscription for a period of time between one week and three months
     * Note that annual subscriptions cannot be paused, and the pause limits of one week and three months are subject to change at any time.
     */
    SubscriptionStatus["PAUSED"] = "Paused";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
var ProductType;
(function (ProductType) {
    ProductType["CONSUMABLE"] = "consumable";
    ProductType["NON_CONSUMABLE"] = "non_consumable";
    ProductType["SUBSCRIPTION"] = "subscription";
    ProductType["RENEWABLE_SUBSCRIPTION"] = "renewable_subscription";
})(ProductType = exports.ProductType || (exports.ProductType = {}));
var SubscriptionGroupNames;
(function (SubscriptionGroupNames) {
    SubscriptionGroupNames["FULL_THROTTLE"] = "TONIT Full Throttle";
    SubscriptionGroupNames["INTERNAL_SUBSCRIPTION_TESTING"] = "internal subscription testing";
})(SubscriptionGroupNames = exports.SubscriptionGroupNames || (exports.SubscriptionGroupNames = {}));
/**
 * for convenience these map directly
 * to IAPHub webhooks
 */
var PurchaseEvents;
(function (PurchaseEvents) {
    /**
     * A product has been purchased. Triggered for a new subscription as well, for a renewal the subscription renewal event is triggered.
     */
    PurchaseEvents["Purchase"] = "purchase";
    /**
     * A purchase has been refunded.
     */
    PurchaseEvents["Refund"] = "refund";
    /**
     * A subscription has been renewed
     */
    PurchaseEvents["SubscriptionRenewal"] = "subscription_renewal";
    /**
     * A subscription renewal has failed but will be retried. You should keep the subscription active and ask the user to check its payment informations.
     */
    PurchaseEvents["SubscriptionRenewalRetry"] = "subscription_renewal_retry";
    /**
     * A subscription has been upgraded, downgraded of crossgraded
     */
    PurchaseEvents["SubscriptionReplace"] = "subscription_replace";
    /**
     * A subscription has been cancelled (but it is still active)
     */
    PurchaseEvents["SubscriptionCancel"] = "subscription_cancel";
    /**
     * A subscription has been uncancelled (but it is still active)
     */
    PurchaseEvents["SubscriptionUncancel"] = "subscription_uncancel";
    /**
     * A subscription has expired
     */
    PurchaseEvents["SubscriptionExpire"] = "subscription_expire";
    /**
     * Initial IAPHUB connection setup will send a test webhook type
     * Need to response with 200 to complete setup
     */
    PurchaseEvents["Test"] = "test";
    /**
     * An user id has been updated.
     *
     * Triggered when an user restore its purchases with a different user id.
     * The purchases of the old user id will be transfered to the new user id.
     */
    PurchaseEvents["UserIdUpdate"] = "user_id_update";
    /**
     * Subscription product change
     *
     * The product of the subscription has been changed,
     * the subscription will be replaced with the new product at the next renewal date.
     * It happens on IOS when having a subscription downgrade or a subscription
     * crossgrade with a different duration.
     */
    PurchaseEvents["SubscriptionProductChange"] = "subscription_product_change";
    /**
     * A subscription grace period has ended but is still in retry period
     */
    PurchaseEvents["SubscriptionGracePeriodExpire"] = "subscription_grace_period_expire";
    /**
     * A subscription has been paused (Android only)
     * You have to restrict the access to the features offered by the subscription.
     */
    PurchaseEvents["SubscriptionPause"] = "subscription_pause";
    /**
     * A subscription pause has been enabled (Android only).
     * The pause isn't active yet, it will occur on the subscription expiration date and you will receive a subscription_pause webhook.
     */
    PurchaseEvents["SubscriptionPauseEnabled"] = "subscription_pause_enabled";
    /**
     * A subscription pause has been disabled (Android only)
     * The subscription will renew on the expiration date.
     */
    PurchaseEvents["SubscriptionPauseDisabled"] = "subscription_pause_disabled";
})(PurchaseEvents = exports.PurchaseEvents || (exports.PurchaseEvents = {}));
var ProductSkus;
(function (ProductSkus) {
    // Testing
    ProductSkus["TestingMonthlySubscription"] = "com.tonitmedia.tonit.internal_monthly_subscription";
    ProductSkus["TestingWeeklySubscription"] = "com.tonitmedia.tonit.internal_weekly_subscription";
    // Live Products
    ProductSkus["FPMonthlySubscription"] = "com.tonitmedia.tonit.ft_monthly_subscription";
    ProductSkus["FPYearlySubscription"] = "com.tonitmedia.tonit.ft_yearly_subscription";
})(ProductSkus = exports.ProductSkus || (exports.ProductSkus = {}));
var PubSubTopics;
(function (PubSubTopics) {
    /**
     * Used when a profile is updated and we want to propagate the updates
     * ie. Algolia, existing comments, existing posts etc.
     */
    PubSubTopics["PROFILE_UPDATE"] = "profileUpdate";
    /**
     * Used for our cron service that gets triggered to run every minute
     */
    PubSubTopics["EVERY_MINUTE"] = "everyMinute";
    /**
     * Used when an event is updated, useful for propagating updates
     * to post attachments
     */
    PubSubTopics["EVENT_UPDATE"] = "eventUpdate";
    // these are for legacy functionality
    /**
     * This is for actions coming thru the firebase actions (legacy clients) queue and being sent to our current actions queue
     */
    PubSubTopics["FIREBASE_ACTIONS"] = "firebaseActions";
    /**
     * This is triggered when we're receiving an update from firebase and we need to sync it with mongo
     */
    PubSubTopics["FIREBASE_MONGO_SYNC"] = "firebaseMongoSync";
})(PubSubTopics = exports.PubSubTopics || (exports.PubSubTopics = {}));
var RecommendationReasons;
(function (RecommendationReasons) {
    RecommendationReasons["CREATED_BY_FOLLOWING"] = "CREATED_BY_FOLLOWING";
    RecommendationReasons["CREATED_NEARBY"] = "CREATED_NEARBY";
    RecommendationReasons["CREATED_BY_HIGH_INCOMING_AFFINITY"] = "CREATED_BY_HIGH_INCOMING_AFFINITY";
    RecommendationReasons["JOINED_BY_HIGH_INCOMING_AFFINITY"] = "JOINED_BY_HIGH_INCOMING_AFFINITY";
})(RecommendationReasons = exports.RecommendationReasons || (exports.RecommendationReasons = {}));
var IconNames;
(function (IconNames) {
    IconNames["WordMark"] = "WordMark";
    IconNames["Album"] = "Album";
    IconNames["Arrow-1"] = "Arrow-1";
    IconNames["Arrow-2"] = "Arrow-2";
    IconNames["Bell"] = "Bell";
    IconNames["Bike"] = "Bike";
    IconNames["Calendar"] = "Calendar";
    IconNames["Camera"] = "Camera";
    IconNames["chatbox"] = "chatbox";
    IconNames["Check"] = "Check";
    IconNames["Check-filled"] = "Check-filled";
    IconNames["Check-unchecked"] = "Check-unchecked";
    IconNames["Chevron"] = "Chevron";
    IconNames["Clock"] = "Clock";
    IconNames["Club"] = "Club";
    IconNames["Comment"] = "Comment";
    IconNames["Cross"] = "Cross";
    IconNames["Crop"] = "Crop";
    IconNames["Event"] = "Event";
    IconNames["Event-outline"] = "Event-outline";
    IconNames["Eye"] = "Eye";
    IconNames["Finish"] = "Finish";
    IconNames["FtEvent"] = "FtEvent";
    IconNames["FtMedia"] = "FtMedia";
    IconNames["FtProfile"] = "FtProfile";
    IconNames["FtLock"] = "FtLock";
    IconNames["FtLogo"] = "FtLogo";
    IconNames["Gear"] = "Gear";
    IconNames["Gift"] = "Gift";
    IconNames["Hashtag"] = "Hashtag";
    IconNames["Home"] = "Home";
    IconNames["Image"] = "Image";
    IconNames["Info"] = "Info";
    IconNames["Jacket"] = "Jacket";
    IconNames["Like"] = "Like";
    IconNames["Locate"] = "Locate";
    IconNames["Location"] = "Location";
    IconNames["Lock"] = "Lock";
    IconNames["Map"] = "Map";
    IconNames["Map-pin"] = "Map-pin";
    IconNames["Menu"] = "Menu";
    IconNames["Messages"] = "Messages";
    IconNames["More"] = "More";
    IconNames["Movie"] = "Movie";
    IconNames["Pause"] = "Pause";
    IconNames["Pencil"] = "Pencil";
    IconNames["Pistons"] = "Pistons";
    IconNames["Play"] = "Play";
    IconNames["Plus"] = "Plus";
    IconNames["Private"] = "Private";
    IconNames["Resume"] = "Resume";
    IconNames["Question"] = "Question";
    IconNames["Search"] = "Search";
    IconNames["Share"] = "Share";
    IconNames["Speedometer"] = "Speedometer";
    IconNames["Star-Filled"] = "Star-Filled";
    IconNames["Star-Outline"] = "Star-Outline";
    IconNames["Store"] = "Store";
    IconNames["Tachometer"] = "Tachometer";
    IconNames["Text"] = "Text";
    IconNames["Tracking"] = "Tracking";
    IconNames["Trash"] = "Trash";
    IconNames["Warning"] = "Warning";
    IconNames["Wheel"] = "Wheel";
    IconNames["Wrench"] = "Wrench";
    IconNames["X"] = "X";
    IconNames["Gifts"] = "Gifts";
    IconNames["Hat"] = "Hat";
    IconNames["SnowLogo"] = "SnowLogo";
    IconNames["Snowflake"] = "Snowflake";
    IconNames["Mail"] = "Mail";
    IconNames["Fullscreen"] = "Fullscreen";
    IconNames["Refresh"] = "Refresh";
    IconNames["Undo"] = "Undo";
    IconNames["VolumeOn"] = "VolumeOn";
    IconNames["VolumeOff"] = "VolumeOff";
    IconNames["Apple"] = "Apple";
    IconNames["Facebook"] = "Facebook";
    IconNames["Time"] = "Time";
    IconNames["LocationOn"] = "LocationOn";
    IconNames["Visibility"] = "Visibility";
    IconNames["VisibilityOff"] = "VisibilityOff";
    IconNames["Triangle"] = "Triangle";
    IconNames["Donate"] = "Donate";
    IconNames["TonitLogoMark"] = "TonitLogoMark";
    IconNames["Equalizer"] = "Equalizer";
})(IconNames = exports.IconNames || (exports.IconNames = {}));
var ImageNames;
(function (ImageNames) {
    ImageNames["ClubsSplash"] = "ClubsSplash";
    ImageNames["ExploreSplash"] = "ExploreSplash";
    ImageNames["HomeSplash"] = "HomeSplash";
    ImageNames["ProfileSplash"] = "ProfileSplash";
    ImageNames["SearchSplash"] = "SearchSplash";
})(ImageNames = exports.ImageNames || (exports.ImageNames = {}));
var PostAttachmentTypes;
(function (PostAttachmentTypes) {
    PostAttachmentTypes["image_with_overlay_card"] = "image_with_overlay_card";
    PostAttachmentTypes["status_bar"] = "status_bar";
    PostAttachmentTypes["text_segment"] = "text_segment";
    PostAttachmentTypes["actions"] = "actions";
    PostAttachmentTypes["layout"] = "layout";
    PostAttachmentTypes["comment_preview"] = "comment_preview";
})(PostAttachmentTypes = exports.PostAttachmentTypes || (exports.PostAttachmentTypes = {}));
var PaywallVariation;
(function (PaywallVariation) {
    PaywallVariation["Profile"] = "Profile";
    PaywallVariation["Events"] = "Events";
    PaywallVariation["RSVP"] = "RSVP";
    PaywallVariation["Media"] = "Media";
})(PaywallVariation = exports.PaywallVariation || (exports.PaywallVariation = {}));
var ClientMediaType;
(function (ClientMediaType) {
    ClientMediaType["video"] = "video";
    ClientMediaType["image"] = "image";
    ClientMediaType["gallery"] = "gallery";
})(ClientMediaType = exports.ClientMediaType || (exports.ClientMediaType = {}));
var OnEventNavigateActions;
(function (OnEventNavigateActions) {
    OnEventNavigateActions["rsvpActionSheeet"] = "rsvpActionSheeet";
    OnEventNavigateActions["shareActionSheet"] = "shareActionSheet";
})(OnEventNavigateActions = exports.OnEventNavigateActions || (exports.OnEventNavigateActions = {}));
var ResourceLifecycle;
(function (ResourceLifecycle) {
    ResourceLifecycle["Published"] = "Published";
})(ResourceLifecycle = exports.ResourceLifecycle || (exports.ResourceLifecycle = {}));
var WelcomeType;
(function (WelcomeType) {
    WelcomeType["Like"] = "Like";
    WelcomeType["Dismiss"] = "Dismiss";
    WelcomeType["VisitProfile"] = "VisitProfile";
})(WelcomeType = exports.WelcomeType || (exports.WelcomeType = {}));
var ActivityPrivacyMode;
(function (ActivityPrivacyMode) {
    ActivityPrivacyMode["Private"] = "private";
    ActivityPrivacyMode["Public"] = "public";
})(ActivityPrivacyMode = exports.ActivityPrivacyMode || (exports.ActivityPrivacyMode = {}));
var SyncStatus;
(function (SyncStatus) {
    SyncStatus["SYNCED"] = "SYNCED";
    SyncStatus["PENDING"] = "PENDING";
})(SyncStatus = exports.SyncStatus || (exports.SyncStatus = {}));
var ContactType;
(function (ContactType) {
    ContactType["Device"] = "Device";
    ContactType["Facebook"] = "Facebook";
})(ContactType = exports.ContactType || (exports.ContactType = {}));
var ContactIdType;
(function (ContactIdType) {
    ContactIdType["Email"] = "Email";
    ContactIdType["Phone"] = "Phone";
    ContactIdType["Facebook"] = "Facebook";
})(ContactIdType = exports.ContactIdType || (exports.ContactIdType = {}));
